import React from 'react'

import { CobrandingLogo } from '@frame/ui-components/cobranding-logo'
import { Footer } from '@frame/ui-components/footer'
import { Body } from '@frame/ui-primitives/body'
import { Button } from '@frame/ui-primitives/button'
import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'

import chatBubble from '@frame/images/chat-bubble.svg'
import { useRootContext } from '@frame/lib/context'
import { useStore } from '@frame/lib/stores/useStore'
import {
  getMortgageOrTenantContact,
  getTextForVerificationType,
  getVerifierDisplayName,
} from '@frame/lib/utils/session'
import { DataAttribute } from '@frame/types'

export function FeedbackComplete() {
  const { events } = useRootContext()
  const { verifierName, consumerInitiated, verificationType, tenantPropertyName, verifierType } = useStore((state) => ({
    verifierName: state.session?.originating_party_display_name,
    consumerInitiated: state.session?.consumer_initiated,
    verificationType: state.session?.verification_type,
    tenantPropertyName: state.session?.configuration?.cobranding?.tenant_property?.property_name,
    verifierType: state.session?.verifier_type,
  }))
  const incomeOrEmployment = getTextForVerificationType(verificationType)
  const displayName = getVerifierDisplayName(verifierType, verifierName, tenantPropertyName)
  const mortgageOrTenantContact = getMortgageOrTenantContact(verifierType)

  return (
    <>
      <Body data-cy={DataAttribute.SCREEN_FEEDBACK_COMPLETE} className="mt-5 p-5">
        <CobrandingLogo />
        <H2 className="my-5">Issue Reported</H2>
        <P>
          {consumerInitiated ? 'You may continue your application.' : 'You may close this window.'} Your{' '}
          {incomeOrEmployment} will be verified another way. Contact your {mortgageOrTenantContact} for additional
          questions.
        </P>
        <img className="mx-auto mt-5" src={chatBubble} />
      </Body>
      {consumerInitiated ? (
        <Footer
          buttons={{
            primary: (
              <Button data-cy={DataAttribute.BTN_CONTINUE_TO_VERIFIER} onClick={() => events.emit('close')}>
                Continue to {displayName}
              </Button>
            ),
          }}
        />
      ) : null}
    </>
  )
}
